import gql from 'graphql-tag';

import { CALENDAR_EVENT_FRAGMENT } from '../../fragments/calendarEvent.fragment';

export const CALENDAR_EVENTS_WITH_ACTIVITIES = gql`
  query CalendarEventsWithActivities($input: CalendarEventsInput!) {
    dealActivity {
      events: calendarEvents(input: $input) {
        error
        success
        list {
          ...CalendarEventFields
        }
      }
      activities: calendarActivities(input: $input) {
        error
        success
        list {
          id
          type
          title
          description
          occurredAt
          parentId
          parentType
        }
      }
    }
  }
  ${CALENDAR_EVENT_FRAGMENT}
`;
